<template>
  <div :class="[classes, '']">
    <a v-if="employee.link" :href="employee.link" class="group">
      <paragraph
        :text="employee.speciality"
        :is-umbraco="isUmbraco"
        :theme="themeType"
        classes="mb-4 font-bold lg:mb-6"
      />
      <custom-image
        v-if="employee.image"
        :alt="employee.imageAltText"
        :image="employee.image"
        classes="w-full h-auto object-cover overflow-hidden"
        loading="lazy"
        is-Link="true"
      />
      <header3
        :text="employee.name"
        :is-umbraco="isUmbraco"
        :theme="themeType"
        classes="mt-8 mb-4"
      />
      <p :class="pStyles">{{ employee.position }}</p>
      <p :class="pStyles">{{ employee.focusArea }}</p>
      <p :class="pStyles">{{ employee.employeeRegion }}</p>
      <rich-text
        :text="employee.description"
        :isUmbraco="isUmbraco"
        :theme="themeType"
        classes="mt-5 lg:mt-6"
      />
    </a>
    <div v-else>
      <paragraph
        :text="employee.speciality"
        :is-umbraco="isUmbraco"
        :theme="themeType"
        classes="mb-4 font-bold lg:mb-6"
      />
      <custom-image
        v-if="employee.image"
        :alt="employee.imageAltText"
        :image="employee.image"
        classes="w-full h-auto object-cover"
        loading="lazy"
      />
      <header3
        :text="employee.name"
        :is-umbraco="isUmbraco"
        :theme="themeType"
        classes="mt-8 mb-4"
      />
      <p :class="pStyles">{{ employee.position }}</p>
      <p :class="pStyles">{{ employee.focusArea }}</p>
      <p :class="pStyles">{{ employee.employeeRegion }}</p>
      <rich-text
        :text="employee.description"
        :isUmbraco="isUmbraco"
        :theme="themeType"
        classes="mt-5 lg:mt-6"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, toRefs } from "vue";
import RichText from "@components/Typography/RichText.ce.vue";
import Header3 from "@components/Typography/Header3.ce.vue";
import CustomImage from "@atoms/Image/Img.vue";
import Paragraph from "@components/Typography/Paragraph.ce.vue";
import { IEployee } from "@/types/components/IEmployeesProps";

export interface IEployeeProps {
  employee: IEployee;
  isUmbraco: boolean;
  themeType: "dark" | "light";
  classes?: string;
}

const props = withDefaults(defineProps<IEployeeProps>(), {
  isUmbraco: false,
});

const { themeType, isUmbraco, employee, classes } = toRefs(props);

const pStyles = computed(() => {
  const color =
    isUmbraco.value && themeType.value === "dark"
      ? "text-white"
      : isUmbraco.value && themeType.value === "light"
      ? "text-aubergine"
      : "text-typography";
  return `${color} text-xs font-bold`;
});
</script>
